import { FILTER_DATE_FROM } from './constants'

const initialState = {
  date: '',
  event: null,
}

export const getFilterDateFrom = (state = initialState, action) => {
  switch (action.type) {
    case FILTER_DATE_FROM:
      return {
        ...state,
        date: action.date,
        event: action.event,
      }
    default:
      return state
  }
}
